import React from 'react';
import {useTranslation} from 'react-i18next';
import {NotificationStatus} from '../../../../incase-domain/notification';
import useNotification from '../../../../service/hooks/useNotification';
import Pagination from '../../../components/common/Pagination';
import NotificationItem from '../../../components/notifications/NotificationItem';
import {useNotificationsListSearchParams} from '../notificationsListSearchParams';

const NOTIFICATION_STATUSES = [NotificationStatus.ACTIVE, NotificationStatus.SEEN, NotificationStatus.READ, NotificationStatus.RESOLVED];

function AllNotifications(): JSX.Element {
    const {t} = useTranslation();

    const {listParams, setListParams} = useNotificationsListSearchParams();
    const paginatedSearch = {
        pageNumber: listParams.page,
        pageSize: listParams.size,
        searchString: listParams.search || undefined,
    };

    const {notifications} = useNotification(paginatedSearch, NOTIFICATION_STATUSES);

    function onDeletePageChangeHandler(deletedCount = 1): void {
        if (!notifications.data) {
            return;
        }

        const newElCount = notifications.data.numberOfElements - deletedCount;
        const newMaxPage = Math.max(Math.ceil(newElCount / notifications.data.pageSize), 1);

        if (listParams.page > newMaxPage) {
            setListParams({page: newMaxPage});
        }
    }

    const numberOfPages = notifications.data ? Math.ceil(notifications.data.numberOfElements / notifications.data.pageSize) : 0;

    return (
        <div>
            {notifications.data?.content.length ? (
                <>
                    {numberOfPages > 1 && (
                        <div className="pagination-wrapper">
                            <Pagination
                                numberOfPages={numberOfPages}
                                page={listParams.page}
                                onPageClick={(pageNumber) => setListParams({page: pageNumber})}
                            />
                        </div>
                    )}
                    <div className="u-flex u-flex-col">
                        {notifications.data.content.map((notification) => (
                            <NotificationItem
                                key={notification._id}
                                notification={notification}
                                paginationInfo={paginatedSearch}
                                onDeletePageChangeHandler={onDeletePageChangeHandler}
                            />
                        ))}
                    </div>
                </>
            ) : (
                <div className="c-errorMessage">{t('notifications.noNotifications')}</div>
            )}
        </div>
    );
}

export default AllNotifications;
